import Legend from '@rio-cloud/rio-uikit/Legend';
import Line from '@rio-cloud/rio-uikit/Line';
import LineChart from '@rio-cloud/rio-uikit/LineChart';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { ICoinsChartData } from '../../../../types/coins';

interface CustomChartProps {
  data: ICoinsChartData[];
}

const CustomChart: React.FC<CustomChartProps> = ({ data }) => {
  return (
    <div className="width-100pct height-100pct rounded-large display-flex align-items-center justify-content-center margin-bottom-32 margin-top-16 margin-x-16 padding-left-20">
      <LineChart
        data={data}
        height={280}
        showGrid
        showYAxis={false}
        xAxisOptions={{
          dataKey: 'mes',
          xAxisId: '0',
          angle: -45,
          textAnchor: 'end',
          height: 60,
          interval: 0
        }}
        gridOptions={{ strokeDasharray: '3 3' }}
        tooltip={<Tooltip />}
        legend={<Legend />}
        lines={[
          <Line
            key="points"
            name="Pontos"
            dataKey="valor"
            strokeColor="color-success"
            activeDot={{ r: 6 }}
            strokeWidth={3}
          />
        ]}
      />
    </div>
  );
};

export default CustomChart;